import { css, useTheme } from '@emotion/react'
import { useRouter } from 'next/router'
import React from 'react'
import { Typography } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'


function ServiceBox({ icon, title, subtitle }) {
    const theme = useTheme()
    const { locale } = useRouter()
    const serviceStyle = css`
        .subtitle {
            color: ${theme.colors.secGray};
        }
        svg {
            position: absolute;
            ${['ar', 'fa'].indexOf(locale) !== -1 ? 'right: -45px;' : 'left: -45px;'}
            font-size: 38px;
            line-height: 38px;
            color: ${theme.colors.primary};
            font-weight: 100;
            top: 2px;
        }
        ${MediaQuery('lg', 'min')} {
            .typography {
                font-size: 0.9rem;
            }
        }
        ${MediaQuery('xl', 'min')} {
            .typography {
                font-size: 1.1rem;
            }
        }
    `
    return (
        <div css={serviceStyle}>
            {icon}
            <Typography type="h5" className="title">{title}</Typography>
            {subtitle && <span className="subtitle">{subtitle}</span>}
        </div>
    )
}

export default ServiceBox